import SideNav from './sidenav';
export default SideNav;



//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/index.ts
// module id = 1573
// module chunks = 1 6 21 23